// extracted by mini-css-extract-plugin
export default {"title":"MDNtYngyEDbvNkJfHyFZ","text":"JzlOpTaZThW2iKlNEm7O"};